import React, { createContext, FC, PropsWithChildren, useState } from 'react';

interface MessageBannerProps {
  message: string;
  iconName?: string;
  messageStyle?: React.CSSProperties;
}

export interface MessageBannerContext {
  messageBanner: MessageBannerProps;
  setMessageBanner: (setMessageBanner: MessageBannerProps) => void;
}

export const MessageBannerContext = createContext<MessageBannerContext>(null);

const MessageBannerContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [messageBanner, setMessageBanner] = useState<MessageBannerProps>(null);

  return (
    <MessageBannerContext.Provider value={{ messageBanner, setMessageBanner }}>
      {children}
    </MessageBannerContext.Provider>
  );
};

export default MessageBannerContextProvider;
